import React from "react";
import Layouts from "../helpers/Layouts/index";
import MainSection from "./MainSection";

export default function TearmsConditions() {
  return (
    <Layouts banner={false}>
      <MainSection />
    </Layouts>
  );
}
